<template>
  <div class="page-default">
    <div
      class="bg-dashboard-dark-2 gallery-container hide-print"
      id="scrollBody"
      @scroll="onScroll"
    >
      <div
        style="display: block; height: 0px"
        class="top"
        id="anchorScrollTop"
      ></div>
      <div class="filter-container">
        <div class="row align-items-center bg-dashboard-dark-1 m-0 row-cols-4">
          <div class="col col-6 col-md-2 border-right px-0 border-outline-dark">
            <div class="dropdown">
              <button
                class="btn btn-sm btn-block no-focus position-relative rounded-0 py-0 px-2 d-flex justify-content-between align-items-center overflow-hidden"
                type="button"
                id="dropdownDistrictButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                @click="
                  dropdownActive == 'district'
                    ? (dropdownActive = '')
                    : (dropdownActive = 'district')
                "
                @blur="dropdownActive = ''"
                data-placement="top"
                @mouseover="helper.showTooltip"
                @mouseleave="helper.hideTooltip"
                title="Filter by District"
              >
                <div
                  class="d-flex justify-content-start align-items-center w-100 py-2"
                >
                  <div class="mr-2">
                    <font-awesome-icon
                      class="text-light"
                      :icon="['fas', 'filter']"
                      :class="{ 'text-primary': currentDistrict }"
                    />
                    <font-awesome-icon
                      :icon="['fas', 'check-circle']"
                      class="text-success bg-dark"
                      style="
                        font-size: 0.85em;
                        position: absolute;
                        top: 1.55em;
                        right: 0.45em;
                      "
                      v-if="currentDistrict"
                    />
                  </div>
                  <div
                    class="text-left overflow-hidden w-100"
                    style="line-height: 1.3"
                  >
                    <p class="small mb-0 text-light">District</p>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <p class="mb-0 text-nowrap text-truncate text-white">
                        {{ currentDistrict ? currentDistrict.name : "All" }}
                      </p>
                      <font-awesome-icon
                        v-if="dropdownActive == 'district'"
                        class="text-white mr-1 angle-icon"
                        style="font-size: 0.65rem"
                        :icon="['fas', 'angle-up']"
                      />
                      <font-awesome-icon
                        v-else
                        class="text-white mr-1 angle-icon"
                        style="font-size: 0.65rem"
                        :icon="['fas', 'angle-down']"
                      />
                    </div>
                  </div>
                </div>
              </button>
              <div
                class="dropdown-menu dropdown-menu-right p-0"
                aria-labelledby="dropdownMenuButton"
                style="max-height: 200px; overflow-y: auto"
              >
                <button
                  class="dropdown-item font-weight-medium d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom fs-8"
                  :class="currentDistrict == null ? 'text-white' : 'text-light'"
                  @click="currentDistrict = null"
                >
                  All districts
                  <font-awesome-icon
                    :icon="['fas', 'check']"
                    class="text-primary ml-3 small"
                    v-if="currentDistrict == null"
                  />
                </button>
                <button
                  v-for="district in userRole == 'Supervisor'
                    ? userDistricts
                    : allDistricts"
                  :key="district._id"
                  class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom fs-8"
                  :class="
                    currentDistrict && currentDistrict._id == district._id
                      ? 'text-white'
                      : 'text-light'
                  "
                  @click="currentDistrict = district"
                >
                  {{ district.name }}
                  <font-awesome-icon
                    :icon="['fas', 'check']"
                    class="text-primary ml-3 small"
                    v-if="
                      currentDistrict && currentDistrict._id == district._id
                    "
                  />
                </button>
              </div>
            </div>
          </div>
          <div class="col col-6 col-md-2 border-right px-0 border-outline-dark">
            <button
              class="btn btn-sm text-left d-flex rounded-0 justify-content-start align-items-center position-relative p-2 w-100 h-100"
              type="button"
              @click="showDateSelector = true"
              data-placement="top"
              @mouseover="helper.showTooltip"
              @mouseleave="helper.hideTooltip"
              title="Filter by Date"
            >
              <div class="mr-2">
                <font-awesome-icon
                  class="text-light"
                  :icon="['far', 'calendar-alt']"
                  :class="{ 'text-primary': dateFilter }"
                />
                <font-awesome-icon
                  :icon="['fas', 'check-circle']"
                  class="text-success bg-dark"
                  style="
                    font-size: 0.85em;
                    position: absolute;
                    top: 1.55em;
                    right: 0.45em;
                  "
                  v-if="dateFilter"
                />
              </div>
              <div class="w-100 overflow-hidden" style="line-height: 1.3">
                <p class="small mb-0 text-light">Date</p>
                <p class="mb-0 text-nowrap text-truncate text-white">
                  {{ dateFilter ? displayDateFilter : "All" }}
                </p>
              </div>
            </button>
          </div>
          <div class="col col-6 col-md-2 border-right px-0 border-outline-dark">
            <div class="dropdown">
              <button
                class="btn btn-sm btn-block no-focus position-relative rounded-0 py-0 px-2 d-flex justify-content-between align-items-center overflow-hidden"
                type="button"
                id="dropdownVerifiedButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                @click="
                  dropdownActive == 'status'
                    ? (dropdownActive = '')
                    : (dropdownActive = 'status')
                "
                @blur="dropdownActive = ''"
                data-placement="top"
                @mouseover="helper.showTooltip"
                @mouseleave="helper.hideTooltip"
                title="Filter by Status"
              >
                <div
                  class="d-flex justify-content-start align-items-center w-100 py-2"
                >
                  <div class="mr-2">
                    <font-awesome-icon
                      class="text-light"
                      :icon="['fas', 'check-double']"
                      :class="{ 'text-primary': verifiedFilter }"
                    />
                    <font-awesome-icon
                      :icon="['fas', 'check-circle']"
                      class="text-success bg-dark"
                      style="
                        font-size: 0.85em;
                        position: absolute;
                        top: 1.55em;
                        right: 0.45em;
                      "
                      v-if="verifiedFilter"
                    />
                  </div>
                  <div
                    class="text-left overflow-hidden w-100"
                    style="line-height: 1.3"
                  >
                    <p class="small mb-0 text-light">Status</p>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <p class="mb-0 text-nowrap text-truncate text-white">
                        {{ verifiedFilter ? verifiedFilter : "All" }}
                      </p>
                      <font-awesome-icon
                        v-if="dropdownActive == 'status'"
                        class="text-white mr-1 angle-icon"
                        style="font-size: 0.65rem"
                        :icon="['fas', 'angle-up']"
                      />
                      <font-awesome-icon
                        v-else
                        class="text-white mr-1 angle-icon"
                        style="font-size: 0.65rem"
                        :icon="['fas', 'angle-down']"
                      />
                    </div>
                  </div>
                </div>
              </button>
              <div
                class="dropdown-menu dropdown-menu-right p-0"
                aria-labelledby="dropdownMenuButton"
                style="max-height: 200px; overflow-y: auto"
              >
                <button
                  class="dropdown-item font-weight-medium d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom fs-8"
                  :class="!verifiedFilter ? 'text-white' : 'text-light'"
                  @click="verifiedFilter = false"
                >
                  All
                  <font-awesome-icon
                    :icon="['fas', 'check']"
                    class="text-primary ml-3 small"
                    v-if="verifiedFilter == null"
                  />
                </button>
                <button
                  class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom fs-8"
                  :class="
                    verifiedFilter && verifiedFilter == 'open'
                      ? 'text-white'
                      : 'text-light'
                  "
                  @click="verifiedFilter = 'open'"
                >
                  Open
                  <font-awesome-icon
                    :icon="['fas', 'check']"
                    class="text-primary ml-3 small"
                    v-if="verifiedFilter && verifiedFilter == 'open'"
                  />
                </button>
                <button
                  class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom fs-8"
                  :class="
                    verifiedFilter && verifiedFilter == 'solved'
                      ? 'text-white'
                      : 'text-light'
                  "
                  @click="verifiedFilter = 'solved'"
                >
                  Closed
                  <font-awesome-icon
                    :icon="['fas', 'check']"
                    class="text-primary ml-3 small"
                    v-if="verifiedFilter && verifiedFilter == 'solved'"
                  />
                </button>
              </div>
            </div>
          </div>
          <div class="col col-6 col-md-2 border-right px-0 border-outline-dark">
            <!-- <div class="dropdown">
              <button
                class="
                  btn btn-sm btn-block
                  no-focus
                  position-relative
                  rounded-0
                  py-0
                  px-2
                  d-flex
                  justify-content-between
                  align-items-center
                  overflow-hidden
                "
                type="button"
                id="dropdownScopeButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                @click="
                  dropdownActive == 'workScope'
                    ? (dropdownActive = '')
                    : (dropdownActive = 'workScope')
                "
                @blur="dropdownActive = ''"
              >
                <div
                  class="
                    d-flex
                    justify-content-start
                    align-items-center
                    w-100
                    py-2
                  "
                >
                  <div class="mr-2">
                    <font-awesome-icon
                      class="text-light"
                      :icon="['fas', 'file-signature']"
                      :class="{ 'text-primary': workScopeFilter }"
                    />
                    <font-awesome-icon
                      :icon="['fas', 'check-circle']"
                      class="text-success bg-dark"
                      style="
                        font-size: 0.85em;
                        position: absolute;
                        top: 1.55em;
                        right: 0.45em;
                      "
                      v-if="workScopeFilter"
                    />
                  </div>
                  <div
                    class="text-left overflow-hidden w-100"
                    style="line-height: 1.3"
                  >
                    <p class="small mb-0 text-light">Work Scope</p>

                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <p class="mb-0 text-nowrap text-truncate text-white">
                        {{ workScopeFilter ? workScopeFilter : "All" }}
                      </p>
                      <font-awesome-icon
                        v-if="dropdownActive == 'workScope'"
                        class="text-white mr-1 angle-icon"
                        style="font-size: 0.65rem"
                        :icon="['fas', 'angle-up']"
                      />
                      <font-awesome-icon
                        v-else
                        class="text-white mr-1 angle-icon"
                        style="font-size: 0.65rem"
                        :icon="['fas', 'angle-down']"
                      />
                    </div>
                  </div>
                </div>
              </button>
              <div
                class="dropdown-menu dropdown-menu-right p-0"
                aria-labelledby="dropdownMenuButton"
                style="max-height: 200px; overflow-y: auto"
              >
                <button
                  class="
                    dropdown-item
                    font-weight-medium
                    d-flex
                    justify-content-between
                    align-items-center
                    py-2
                    px-3
                    btn-secondary
                    border-outline-dark-bottom
                    fs-8
                  "
                  :class="workScopeFilter == null ? 'text-white' : 'text-light'"
                  @click="workScopeFilter = null"
                >
                  All scopes
                  <font-awesome-icon
                    :icon="['fas', 'check']"
                    class="text-primary ml-3 small"
                    v-if="workScopeFilter == null"
                  />
                </button>
                <button
                  v-for="scope in workScopes"
                  :key="`scope-${scope}`"
                  class="
                    dropdown-item
                    d-flex
                    justify-content-between
                    align-items-center
                    py-2
                    px-3
                    btn-secondary
                    border-outline-dark-bottom
                    fs-8
                  "
                  :class="
                    workScopeFilter == scope ? 'text-white' : 'text-light'
                  "
                  @click="workScopeFilter = scope"
                >
                  {{ scope }}
                  <font-awesome-icon
                    :icon="['fas', 'check']"
                    class="text-primary ml-3 small"
                    v-if="workScopeFilter == scope"
                  />
                </button>
              </div>
            </div> -->
            <div class="dropdown">
              <button
                class="btn btn-sm btn-block no-focus position-relative rounded-0 py-0 px-2 d-flex justify-content-between align-items-center overflow-hidden"
                type="button"
                id="dropdownScopeButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                @click="
                  dropdownActive == 'workScope'
                    ? (dropdownActive = '')
                    : (dropdownActive = 'workScope')
                "
                @blur="dropdownActive = ''"
                data-placement="top"
                @mouseover="helper.showTooltip"
                @mouseleave="helper.hideTooltip"
                title="Filter by Workscope"
              >
                <div
                  class="d-flex justify-content-start align-items-center w-100 py-2"
                >
                  <div class="mr-2">
                    <font-awesome-icon
                      class="text-light"
                      :icon="['fas', 'file-signature']"
                      :class="{ 'text-primary': !showAllWorkLayer }"
                    />
                    <font-awesome-icon
                      :icon="['fas', 'check-circle']"
                      class="text-success bg-dark"
                      style="
                        font-size: 0.85em;
                        position: absolute;
                        top: 1.55em;
                        right: 0.45em;
                      "
                      v-if="!showAllWorkLayer"
                    />
                  </div>
                  <div
                    class="text-left overflow-hidden w-100"
                    style="line-height: 1.3"
                  >
                    <p class="small mb-0 text-light">Work Scope</p>

                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <p class="mb-0 text-nowrap text-truncate text-white">
                        {{
                          workScopes.filter((item) => item.show === false)
                            .length === 0
                            ? "All"
                            : workScopes.filter((item) => item.show === true)
                                .length === 0
                            ? "-"
                            : workScopes
                                .filter((item) => item.show === true)
                                .map((x) => {
                                  return x.name;
                                })
                                .toString()
                        }}
                      </p>
                      <font-awesome-icon
                        v-if="dropdownActive == 'workScope'"
                        class="text-white mr-1 angle-icon"
                        style="font-size: 0.65rem"
                        :icon="['fas', 'angle-up']"
                      />
                      <font-awesome-icon
                        v-else
                        class="text-white mr-1 angle-icon"
                        style="font-size: 0.65rem"
                        :icon="['fas', 'angle-down']"
                      />
                    </div>
                  </div>
                </div>
              </button>
              <div
                class="dropdown-menu dropdown-menu-right p-0"
                aria-labelledby="dropdownMenuButton"
                style="max-height: 200px; overflow-y: auto"
              >
                <div
                  class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom fs-8"
                  @click="handleSelectAllWorkLayers"
                >
                  <div class="custom-control custom-checkbox py-2">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      v-model="showAllWorkLayer"
                    />
                    <label
                      class="custom-control-label text-nowrap text-white fs-8"
                    >
                      {{
                        showAllWorkLayer
                          ? "Deselect all Scopes"
                          : "Select all Scopes"
                      }}
                    </label>
                  </div>
                </div>
                <div
                  v-for="scope in workScopes"
                  :key="scope.id"
                  class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-dark-bottom fs-8"
                  @click="(e) => handleWorkScope(e, scope.id)"
                >
                  <div class="custom-control custom-checkbox py-2">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      :id="scope.id"
                      :checked="scope.show"
                      @click.stop
                    />
                    <label
                      class="custom-control-label text-nowrap text-white fs-8"
                      :for="scope.id"
                    >
                      {{ scope.name }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="loading-img rounded-pill w-100 px-4 py-2 d-flex justify-content-center align-items-center"
      >
        <div v-if="!isProcessing">
          <Button
            class="btn btn-dark rounded-pill shadow-lg"
            @click="handleScrollDown"
            v-show="visibleButtonScrollBottom"
            v-if="cases.length > 0"
            data-bs-toggle="tooltip2"
            data-bs-placement="top"
            :title="
              totalPage >= currentPage
                ? totalPage == currentPage
                  ? 'Go to bottom'
                  : 'Load more photos'
                : cases.length == 0
                ? 'No Photo'
                : 'End of photo'
            "
            style="opacity: 0.8"
            data-placement="top"
            @mouseover="helper.showTooltip"
            @mouseleave="helper.hideTooltip"
          >
            <font-awesome-icon
              class="mr-2 align-middle"
              :icon="['fas', 'angle-down']"
            />
            {{
              totalPage >= currentPage
                ? totalPage == currentPage
                  ? "Go to bottom"
                  : "Load more photos"
                : cases.length == 0
                ? "No Photo"
                : "End of photo"
            }}
          </Button>
          <Button
            class="btn btn-dark rounded-pill shadow-lg ml-2"
            @click="handleScrollTop"
            v-show="visibleButtonScrollTop"
            v-if="cases.length > 0"
            data-bs-toggle="tooltip1"
            data-bs-placement="bottom"
            title="Back to top"
            style="opacity: 0.8"
            data-placement="top"
            @mouseover="helper.showTooltip"
            @mouseleave="helper.hideTooltip"
            ><font-awesome-icon
              class="mr-2 align-middle"
              :icon="['fas', 'angle-up']"
            />Back to top</Button
          >
        </div>

        <div
          v-else
          class="rounded-pill bg-dashboard-dark-1 px-4 py-2 d-flex align-items-center shadow-lg text-white"
        >
          <div
            class="spinner-border spinner-border-sm mr-3"
            role="status"
          ></div>
          Loading ...
        </div>
      </div>

      <div
        class="row g-0 m-0 px-2 h-100 w-100 align-items-center justify-content-center"
        v-if="cases.length == 0"
      >
        <div class="col-3">
          <div class="text-center" v-if="!isProcessing">
            <font-awesome-icon
              :icon="['fas', 'images']"
              class="text-muted mb-2"
              style="font-size: 2rem"
            />
            <p class="text-muted text-center">No case found</p>
          </div>
          <div class="text-center" v-else>
            <font-awesome-icon
              :icon="['fas', 'images']"
              class="text-muted mb-2"
              style="font-size: 2rem"
            />
            <p class="text-muted text-center">Loading ...</p>
          </div>
        </div>
      </div>

      <div class="row g-0 m-0 px-2" v-else>
        <div class="col-sm-6 col-md-2 px-1" v-for="(item, i) in cases" :key="i">
          <div
            class="card bg-dashboard-dark-1 mb-2 is-flex justify-content-center align-items-center"
            style="overflow: hidden; height: 200px"
          >
            <div class="card-body p-0 group-cards">
              <ImageLazy
                v-if="generateImage(item)"
                class="photo"
                :src="helper.formatMediaUrl(generateImage(item))"
                :srcset="helper.formatMediaUrl(generateImage(item))"
                baseClass="image-lazy"
                deferredClass="image-lazy-deferred"
                loadingClass="image-lazy-loading"
                loadedClass="image-lazy-loaded"
                style="width: 160%"
                @loading="loading = true"
                @load="loaded = true"
                @click="handleClickImage(item)"
              />
              <!-- <img v-else src="@/assets/no_image.png" style="width: 100%; background: invert" /> -->
              <div v-else>
                <div class="text-center text-mute">
                  <p class="m-0" style="font-size: 2.5rem">
                    <font-awesome-icon
                      class="align-middle"
                      :icon="['fas', 'image']"
                    />
                  </p>
                </div>
                <p class="text-mute m-0 text-uppercase">No image</p>
              </div>
              <div class="body-overlay" @click="handleClickImage(item)">
                <div
                  class="p-3 d-flex align-items-end"
                  style="height: 100%"
                  data-placement="bottom"
                  @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip"
                  title="Click to view image"
                >
                  <div>
                    <div>
                      <span
                        class="badge badge-info text-dark badge-pill mb-2 align-middle"
                        v-if="item.isNoe"
                      >
                        NOE
                      </span>
                      <span
                        class="badge badge-warning badge-pill mb-2 align-middle"
                        v-else-if="item.isNod"
                      >
                        NOD
                      </span>
                      <span
                        class="badge badge-success text-dark badge-pill mb-2 align-middle"
                        v-if="item.status == 'solved'"
                      >
                        Closed
                      </span>
                      <span
                        class="badge badge-danger badge-pill align-middle mb-2"
                        v-else-if="item.status != 'solved'"
                      >
                        Open
                      </span>
                    </div>
                    <div
                      class="title text-light fw-bold text-uppercase"
                      style="font-size: 0.8rem"
                    >
                      [#{{ item.index }}]
                      {{ helper.formatDate(item.timestamp) }}
                    </div>
                    <div
                      class="title text-white fw-normal text-uppercase"
                      style="font-size: 0.6rem"
                    >
                      {{ item.caption }}
                    </div>
                    <div
                      class="description text-white fw-light"
                      style="font-size: 0.6rem"
                    >
                      {{
                        helper.getRoadInfo({
                          name:
                            item.road && item.road.name ? item.road.name : "",
                          district:
                            item.road && item.road.district
                              ? item.road.district
                              : "",
                        })
                      }}
                    </div>
                    <router-link
                      v-if="
                        item.caseNumber != undefined || item.caseNumber != null
                      "
                      :to="{ name: 'cases', params: { id: item.caseNumber } }"
                      class="btn btn-outline-light btn-sm rounded mt-2"
                      @click.native.stop="handleGoToCase"
                      data-placement="top"
                      @mouseover.native="helper.showTooltip"
                      @mouseleave.native="helper.hideTooltip"
                      title="Click to view details"
                    >
                      Go to Case
                      <font-awesome-icon
                        class="ml-1 align-middle"
                        :icon="['fas', 'angle-right']"
                      />
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div id="anchorScrollBottom"></div>
          <div class="last" style="height: 20px; width: 100%"></div>
        </div>
      </div>
    </div>
    <media-preview
      :downloadImage="true"
      v-if="currentMedia != null"
      :url="helper.formatMediaUrl(currentMedia)"
      @close="handleClose()"
      @navigate="navigateMediaPreview"
      :hasNavigation="{
        previous: getCurrentDefectIndex() > 0,
        next:
          getCurrentDefectIndex() < filteredDefects(currentImages).length - 1,
      }"
    />
    <date-selector
      v-if="showDateSelector"
      :dateRange="dateFilter"
      :isRange="true"
      @close="dateSelected"
    />
  </div>
</template>
<script>
import $ from 'jquery';
import API from "@/api";
import Helper from "@/helper";
import MediaPreview from "@/components/MediaPreview";
import Spinner from "@/components/Spinner";
import ImageLazy from "cube-vue-image-lazy";
import DateSelector from "@/components/DateSelector";
import Moment from "moment";

let initialArrayWorkLayer = [
  {
    id: "unregistered",
    layer: "",
    name: "Others",
    show: true,
  },
  {
    id: "KKE",
    layer: "",
    name: "KKE",
    show: true,
  },
  {
    id: "R01",
    layer: "",
    name: "R01",
    show: true,
  },
  {
    id: "R02",
    layer: "",
    name: "R02",
    show: true,
  },
  {
    id: "R03",
    layer: "",
    name: "R03",
    show: true,
  },
  {
    id: "R04",
    layer: "",
    name: "R04",
    show: true,
  },
  {
    id: "R05",
    layer: "",
    name: "R05",
    show: true,
  },
  {
    id: "R06",
    layer: "",
    name: "R06",
    show: true,
  },
  {
    id: "R07",
    layer: "",
    name: "R07",
    show: true,
  },
  {
    id: "R11",
    layer: "",
    name: "R11",
    show: true,
  },
];

export default {
  name: "gallery",
  components: {
    MediaPreview,
    Spinner,
    ImageLazy,
    DateSelector,
  },
  data() {
    return {
      currentImages: [],
      showAllWorkLayer: true,
      arrays: 40,
      helper: Helper,
      isProcessing: false,
      casesCount: 0,
      totalPage: 1,
      inputPage: 1,
      currentPage: 1,
      pageLimit: 102,
      cases: [],
      currentMedia: null,
      loading: false,
      loaded: false,
      visibleButtonScrollTop: false,
      visibleButtonScrollBottom: true,
      showDateSelector: false,
      dropdownActive: "",
      allDistricts: [],
      scrolledToBottom: false,
      logTarget: "",
      userDistricts: [],
      currentDistrict: null,
      userRole: null,
      dateFilter: null,
      verifiedFilter: null,
      workScopeFilter: initialArrayWorkLayer,
      workScopes: initialArrayWorkLayer,
    };
  },
  computed: {
    displayDateFilter() {
      if (this.dateFilter) {
        if (this.dateFilter.start == this.dateFilter.end) {
          return Moment(this.dateFilter.start).format("D MMM YYYY");
        } else if (
          Moment(this.dateFilter.start).format("MM-YYYY") ==
          Moment(this.dateFilter.end).format("MM-YYYY")
        ) {
          return `${Moment(this.dateFilter.start).format("D")} - ${Moment(
            this.dateFilter.end
          ).format("D MMM YYYY")}`;
        } else if (
          Moment(this.dateFilter.start).format("YYYY") ==
          Moment(this.dateFilter.end).format("YYYY")
        ) {
          return `${Moment(this.dateFilter.start).format("D MMM")} - ${Moment(
            this.dateFilter.end
          ).format("D MMM YYYY")}`;
        } else {
          return `${Moment(this.dateFilter.start).format(
            "D MMM YYYY"
          )} - ${Moment(this.dateFilter.end).format("D MMM YYYY")}`;
        }
      } else {
        return null;
      }
    },
  },
  watch: {
    currentDistrict: {
      handler() {
        const newItem = this.workScopes;
        const checking = newItem.filter((x) => x.show === true);
        if (checking.length > 0) {
          this.resetInitialValue();
          this.changePage(1, true);
        }
      },
      immediate: false,
    },
    verifiedFilter: {
      handler() {
        const newItem = this.workScopes;

        const checking = newItem.filter((x) => x.show === true);

        if (checking.length > 0) {
          this.resetInitialValue();
          this.changePage(1, true);
        }
      },
      immediate: false,
    },
    workScopeFilter: {
      handler() {
        const newItem = this.workScopes;
        const checking = newItem.filter((x) => x.show === true);
        if (checking.length > 0) {
          this.resetInitialValue();
          // this.changePage(1, true);
        }
      },
      immediate: false,
    },
    scrolledToBottom() {
      if (this.scrolledToBottom && this.currentPage < this.totalPage) {
        this.changePage(this.currentPage + 1, true);
      }
    },
  },
  methods: {
    filteredDefects(defects) {
      return defects ? defects : [];
    },
    getCurrentDefectIndex() {
      return this.filteredDefects(this.currentImages).findIndex(
        (defect) => defect._id == this.currentMedia._id
      );
    },
    navigateMediaPreview(e) {
      if (this.currentImages && this.currentMedia) {
        const currentDefectIndex = this.getCurrentDefectIndex();

        if (e == "previous" && currentDefectIndex > 0) {
          this.helper.closeKeyboardBtn("previous_image");
          this.currentMedia = null;
          this.$nextTick(() => {
            this.helper.closeKeyboardBtn();
            this.currentMedia = this.filteredDefects(this.currentImages)[
              currentDefectIndex - 1
            ];
          });
        } else if (
          e == "next" &&
          currentDefectIndex <
            this.filteredDefects(this.currentImages).length - 1
        ) {
          this.currentMedia = null;
          this.$nextTick(() => {
            this.helper.closeKeyboardBtn("next_image");
            this.currentMedia = this.filteredDefects(this.currentImages)[
              currentDefectIndex + 1
            ];
          });
        }
      }
    },
    handleSelectAllWorkLayers(e) {
      e.stopPropagation();

      this.cases = [];

      this.showAllWorkLayer = !this.showAllWorkLayer;

      const data = this.workScopes;
      const remap = data.map((x) => {
        return {
          ...x,
          show: this.showAllWorkLayer ? true : false,
        };
      });

      this.workScopes = remap;
      this.workScopeFilter = remap;

      const checking = remap.filter((x) => x.show === false);

      if (checking.length === 0) {
        this.changePage(1, true);
      }
    },
    handleWorkScope(e, id) {
      e.preventDefault();

      this.cases = [];

      const newItem = this.workScopes;
      const index = newItem.findIndex((x) => x.id === id);
      const item = newItem[index];

      let newObj = {
        ...item,
        show: !item.show,
      };

      newItem.splice(index, 1, { ...item, ...newObj });
      this.workScopes = newItem;
      this.workScopeFilter = newItem;

      const checking = newItem.filter((x) => x.show === true);
      if (checking.length > 0) {
        this.changePage(1, true);
      }
    },
    dateSelected(e) {
      const newItem = this.workScopes;
      const checking = newItem.filter((x) => x.show === true);

      if (typeof e == "object") {
        this.dateFilter = {
          start: Moment(e.start).format("YYYY-MM-DD"),
          end: Moment(e.end).format("YYYY-MM-DD"),
        };
        if (checking.length > 0) {
          this.resetInitialValue();
          this.changePage(1, true);
        }
      } else if (typeof e == "boolean" && e == false) {
        this.dateFilter = null;
        if (checking.length > 0) {
          this.resetInitialValue();
          this.changePage(1, true);
        }
      }

      this.showDateSelector = null;
    },
    resetInitialValue() {
      this.cases = [];
      this.casesCount = 0;
      this.totalPage = 1;
      this.inputPage = 1;
      this.currentPage = 1;
      this.pageLimit = 102;
    },
    handleScrollTop() {
      var element = document.getElementById("anchorScrollTop");
      element.scrollIntoView({ behavior: "smooth" });
    },
    handleScrollDown() {
      var element = document.getElementById("anchorScrollBottom");
      element.scrollIntoView({ behavior: "smooth" });
    },
    onScroll() {
      if (this.cases.length > 0) {
        let elementTop = document.querySelector(".top");
        const rectTop = elementTop.getBoundingClientRect();

        const isInViewportTop = rectTop.top < 0;

        this.visibleButtonScrollTop = isInViewportTop ? true : false;
        this.visibleButtonScrollBottom =
          !isInViewportTop || this.currentPage != this.totalPage ? true : false;

        let elementBot = document.querySelector(".last");
        const rectBot = elementBot.getBoundingClientRect();
        const isInViewportBottom =
          rectBot.top >= 0 &&
          rectBot.bottom <=
            (window.innerHeight || document.documentElement.clientHeight);
        if (isInViewportBottom) {
          this.scrolledToBottom = true;
        }
      }
    },
    handleGoToCase(e) {
      $(e.target).tooltip('dispose');
    },
    async changePage(page, force) {
      const x = parseInt(page);

      if (x != this.currentPage || force) {
        if (x > this.totalPage || x < 1) {
          this.inputPage = this.currentPage;

          if (force) {
            await this.getCases();
          }
        } else {
          this.currentPage = x;
          this.inputPage = x;

          await this.getCases();
        }
      }
    },
    handleClose() {
      this.currentMedia = null;
    },
    handleClickImage(item) {
      // console.log('====================================');
      // console.log(item);
      // console.log('====================================');
      // console.log('====================================');
      // console.log(this.generateImage(item));
      // console.log('====================================');
      this.currentMedia = this.generateImage(item)
        ? this.generateImage(item)
        : "";
    },
    generateImage(file) {
      if (file.media_after.length > 0) {
        return file.media_after[0];
      } else if (file.media_during.length > 0) {
        return file.media_during[0];
      } else if (file.media.length > 0) {
        return file.media[0];
      } else {
        return "";
      }
    },
    getDistrictName(id) {
      const district = this.allDistricts.find((d) => d._id == id);

      if (id && district) {
        return district.name;
      } else {
        return null;
      }
    },
    async getDistricts() {
      this.isProcessing = true;

      let url = "districts?_sort=name";

      if (this.userRole == "Supervisor" && this.userDistricts.length > 0) {
        url = url
          .concat("&_id_in=")
          .concat(
            this.userDistricts.map((district) => district._id).join("&_id_in=")
          );
      }

      return API.get(url)
        .then((retVal) => {
          this.allDistricts = retVal.data;

          this.isProcessing = false;
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;
        });
    },
    filterByWorkScope(cases) {
      const realLayers = this.workScopes.filter((x) => x.id !== "unregistered");
      const knownLayerIds = realLayers.map((x) => x.id);
      const checkedLayers = realLayers.filter((x) => x.show).map((x) => x.id);

      const othersScope = this.workScopes.find((x) => x.id === "unregistered");
      const othersChecked = !!othersScope?.show;

      return cases.filter((c) => {
        // "Others" covers both no reportType and any reportType that
        // doesn't match one of the layer checkboxes we render (e.g. a
        // legacy value) - one toggle for both cases.
        const isOthers = !c.reportType || !knownLayerIds.includes(c.reportType);

        if (isOthers) {
          return othersChecked;
        }

        return checkedLayers.includes(c.reportType);
      });
    },
    async getCases() {
      this.isProcessing = true;
      this.scrolledToBottom = false;

      let query = `source_ne=socialMedia&_sort=timestamp:DESC&_limit=${this.pageLimit}`;

      if (this.currentDistrict) {
        query += `&district=${this.currentDistrict._id}`;
      } else if (
        this.userRole == "Supervisor" &&
        this.userDistricts.length > 0
      ) {
        query += `&district_in=${this.userDistricts
          .map((ud) => ud._id)
          .join("&district_in=")}`;
      }

      if (this.dateFilter && this.dateFilter.start && this.dateFilter.end) {
        const _dateFilter = {
          start: Moment(this.dateFilter.start).startOf("day").toISOString(),
          end: Moment(this.dateFilter.end).endOf("day").toISOString(),
        };

        query += `&timestamp_gte=${_dateFilter.start}&timestamp_lte=${_dateFilter.end}`;
      }

      // reportType/work-scope filtering (including the "no report type"
      // bucket) can't be expressed as a single Strapi query - it needs an
      // OR between "reportType is null/unrecognized" and "reportType in
      // [...]", which Strapi v3's flat filter params can't do. Applied
      // client-side instead via filterByWorkScope() on the fetched results.

      if (this.currentPage == 1) {
        this.casesCount = (await API.get(`cases/count?${query}`)).data;

        this.totalPage = Math.ceil(this.casesCount / this.pageLimit);
      }

      if (this.currentPage < this.totalPage) {
        query += `&_start=${(this.currentPage - 1) * this.pageLimit}`;
      }
      if (this.currentPage == 1 || this.currentPage < this.totalPage) {
        try {
          const { data } = await API.get(`cases?${query}`);

          const newItem = [...this.cases, ...data];
          const filterItem = newItem.filter((item) => item.media.length != 0);

          let _filteredData = this.filterByWorkScope(filterItem);

          if (this.verifiedFilter && this.verifiedFilter == "solved") {
            _filteredData = _filteredData.filter((d) => d.status == "solved");
          }

          if (this.verifiedFilter && this.verifiedFilter == "open") {
            _filteredData = _filteredData.filter((d) => d.status != "solved");
          }

          this.cases = _filteredData.map((c, index) => {
            c.index = index + 1;

            return c;
          });

          this.currentImages = this.cases.map(x => {
            return !this.generateImage(x) ? null : this.generateImage(x)
          })
        } catch (error) {}
      }
      this.isProcessing = false;
    },
  },
  async mounted() {
    let _user = localStorage.getItem("user");

    if (_user) {
      _user = JSON.parse(_user);

      if (_user.districts && _user.districts.length > 0) {
        this.userDistricts = _user.districts.map((district) => {
          return {
            _id: district._id,
            name: district.name,
          };
        });
      }

      this.userRole = _user.role.name;
    }

    await this.getDistricts();

    await this.changePage(1, true);
  },
};
</script>
<style lang="scss">
@import "@/assets/css/print.scss";
</style>